import React, { useEffect, useState} from 'react';
import { Form, Select, Checkbox } from 'antd';
import { Area } from '../../../../../models/JuradosModel/jurados.model';
import { UseVerConvocatorias } from "../../../../../hooks/UseVerConvocatorias";
import apiMaestras from "../../../../../api/Maestras/api-maestras";

const { Option } = Select;

type SelectCategoriaProps = {
    areas: Area[],
    handleConocimientoChange: any,
    handleAreaPrincipalChange: any
    areaPrincipal: any,
    conocimiento: any,
}


export const SelectCategoria = ({ areas, handleConocimientoChange, handleAreaPrincipalChange, areaPrincipal, conocimiento }: SelectCategoriaProps) => {

  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();

  useEffect(() => {
    getConvocatoriaPersistente();
    getLineasConvocatorias();
  }, []);

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  const lineaConvocatoria = getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""

  const opciones = [
    "Punk",
    "Metal",
    "Core",
    "Rock, hard rock",
    "Rap",
    "Ska y reggae",
  ];

  const [checkedList, setCheckedList] = useState<string[]>([]);

  useEffect(() => {
    localStorage.setItem(
      "generos",
      JSON.stringify(checkedList)
    );
  }, [checkedList]);


  const onChange = (values: string[]) => {
    setCheckedList(values);
  };

    return (
        <Form layout="vertical">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Item label="Tipo de conocimiento" className='no-margin'>
                      {
                        !(lineaConvocatoria.includes('Infraestructura')) && (
                          <Select placeholder="Seleccionar..." onChange={handleConocimientoChange} value={conocimiento}>
                            <Option value={'Experto con título'}>Experto con título de educación formal</Option>
                            <Option value={'Experto sin título'}>Experto sin título de educación formal</Option>
                          </Select>
                        )
                      }
                      {
                        (lineaConvocatoria.includes('Infraestructura')) && (
                          <Select placeholder="Seleccionar..." onChange={handleConocimientoChange} value={conocimiento}>
                            <Option value={'Experto con título'}>Experto con título de educación formal</Option>
                          </Select>
                        )
                      }
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                        {
                          (!(lineaConvocatoria.includes('Infraestructura')) && !(lineaConvocatoria.includes('Altavoz'))) && (
                            <Form.Item label="Expresiones culturales">
                              <Select
                                  placeholder="Seleccionar..."
                                  showSearch
                                  filterOption={(input, option: any) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                  onChange={handleAreaPrincipalChange}
                                  value={areaPrincipal}
                              >
                                  {areas.map(({ id_area, nombre_area }) =>
                                    !(
                                      nombre_area.includes('Compra de escenarios') ||
                                      nombre_area.includes('Estudios y diseños') ||
                                      nombre_area.includes('Construcción, mejoramiento y a') ||
                                      nombre_area.includes('Dotación de infraestructura cu') ||
                                      nombre_area.includes('Altavoz')
                                    ) && (
                                      <Option key={id_area} value={id_area}>
                                        {nombre_area}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            </Form.Item>
                          )
                        }
                        {
                          lineaConvocatoria.includes('Infraestructura') && (
                            <Form.Item label="Línea de participación">
                              <Select
                                  placeholder="Seleccionar..."
                                  value={areaPrincipal}
                                  onChange={handleAreaPrincipalChange}
                              >
                                  {areas.map(({ id_area, nombre_area }) =>
                                    (
                                      nombre_area.includes('Compra de escenarios') ||
                                      nombre_area.includes('Estudios y diseños') ||
                                      nombre_area.includes('Construcción, mejoramiento y a') ||
                                      nombre_area.includes('Dotación de infraestructura cu')
                                    ) && (
                                      <Option key={id_area} value={id_area}>
                                        {nombre_area}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            </Form.Item>
                          )
                        }
                        {
                          lineaConvocatoria.includes('Altavoz') && (
                            <Form.Item label="Expresión cultural">
                              <Select
                                  placeholder="Seleccionar..."
                                  value={areaPrincipal}
                                  onChange={handleAreaPrincipalChange}
                              >
                                  {areas.map(({ id_area, nombre_area }) =>
                                    (
                                      nombre_area.includes('Altavoz')
                                    ) && (
                                      <Option key={id_area} value={id_area}>
                                        {nombre_area}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            </Form.Item>
                          )
                        }
                        {
                          lineaConvocatoria.includes('Altavoz') && (
                            <Form.Item label="Género">
                              <Checkbox.Group
                                value={checkedList}
                                onChange={onChange}
                              >
                                {opciones.map((op) => (
                                  <Checkbox key={op} value={op}>
                                    {op}
                                  </Checkbox>
                                ))}
                              </Checkbox.Group>
                            </Form.Item>
                          )
                        }
                </div>
            </div>
        </Form>
    )
}
